import styled from 'styled-components';

export const StyledFormsTemplateReadOnlyNoInformation = styled.span`
   color: ${(props) => props.theme.placeholder};
`;
StyledFormsTemplateReadOnlyNoInformation.displayName = 'StyledFormsTemplateReadOnlyNoInformation';
